import TagAlertValue from '@/modules/core/models/TagAlertValue'

export default class PetsConfigurationTags {
  holderAlert?: TagAlertValue
  personalDataAlert?: TagAlertValue
  contactDataAlert?: TagAlertValue
  contactRcDataAlert?: TagAlertValue
  insuranceInForceAlert?: TagAlertValue
  civilLiabilityAlert?: TagAlertValue
  personalDataInsuredAlert?: TagAlertValue

  constructor(data: any = {}) {
    if (data.holderAlert) this.holderAlert = new TagAlertValue(data.holderAlert)
    if (data.personalDataAlert) this.personalDataAlert = new TagAlertValue(data.personalDataAlert)
    if (data.contactDataAlert) this.contactDataAlert = new TagAlertValue(data.contactDataAlert)
    if (data.insuranceInForceAlert)
      this.insuranceInForceAlert = new TagAlertValue(data.insuranceInForceAlert)
    if (data.civilLiabilityAlert)
      this.civilLiabilityAlert = new TagAlertValue(data.civilLiabilityAlert)
    if (data.contactRcDataAlert)
      this.contactRcDataAlert = new TagAlertValue(data.contactRcDataAlert)
    if (data.personalDataInsuredAlert)
      this.personalDataInsuredAlert = new TagAlertValue(data.personalDataInsuredAlert)
  }
}
